import * as React from 'react';
import * as PropTypes from 'prop-types';
import { Card } from '../card/Card';
import { CardHeader } from '../card/CardHeader';
import { CardTitle } from '../card/CardTitle';
import { CardSubtitle } from '../card/CardSubtitle';
import { CardBody } from '../card/CardBody';
import { CardImage } from '../card/CardImage';
import { CardActions } from '../card/CardActions';
import { Button } from '@progress/kendo-react-buttons';
import { classNames } from '@progress/kendo-react-common';
import { Reveal } from '@progress/kendo-react-animation';
import { chevronRightIcon } from '@progress/kendo-svg-icons';
export var TimelineCard = function (props) {
    var animationDuration = 400;
    var _a = props.eventData, title = _a.title, subtitle = _a.subtitle, actions = _a.actions, images = _a.images, description = _a.description;
    var _b = React.useState(true), collapse = _b[0], setCollapse = _b[1];
    var _c = React.useState(true), collapsed = _c[0], setCollapsed = _c[1];
    var toggleCard = function (event) {
        setCollapse(!collapse);
        if (props.onChange) {
            var toggleEvent = {
                syntheticEvent: event,
                nativeEvent: event.nativeEvent,
                eventData: props.eventData
            };
            props.onChange.call(undefined, toggleEvent);
        }
    };
    var actionClick = function (event) {
        if (props.onActionClick) {
            var actionClickEvent = {
                syntheticEvent: event,
                nativeEvent: event.nativeEvent,
                eventData: props.eventData
            };
            props.onActionClick.call(undefined, actionClickEvent);
        }
    };
    var cardBody = function () { return (React.createElement(CardBody, null,
        React.createElement("div", { className: "k-card-description" },
            React.createElement("p", null, description),
            images && images.map(function (image, index) { return (React.createElement(CardImage, { key: index, src: image.src })); })),
        React.createElement(CardActions, null, actions && actions.map(function (action, index) { return (React.createElement("a", { key: index, href: action.url, className: "k-button k-button-md k-rounded-md k-button-flat k-button-flat-primary", onClick: actionClick }, action.text)); })))); };
    return (React.createElement("div", { className: classNames('k-timeline-card', { 'k-collapsed': props.collapsible && collapsed }) },
        React.createElement(Card, { className: "k-card-with-callout" },
            React.createElement("span", { className: classNames('k-timeline-card-callout', 'k-card-callout', { 'k-callout-e': props.alternated }, { 'k-callout-w': !props.alternated }) }),
            React.createElement("div", { className: "k-card-inner" },
                React.createElement(CardHeader, null,
                    React.createElement(CardTitle, null,
                        React.createElement("span", { className: "k-event-title" }, title),
                        props.collapsible && React.createElement(Button, { fillMode: 'flat', icon: 'chevron-right', svgIcon: chevronRightIcon, onClick: function (event) { return toggleCard(event); }, className: 'k-event-collapse' })),
                    subtitle && React.createElement(CardSubtitle, null, subtitle)),
                props.collapsible ?
                    React.createElement(Reveal, { transitionEnterDuration: animationDuration, transitionExitDuration: animationDuration, onBeforeEnter: function () { return setCollapsed(false); }, onAfterExited: function () { return setCollapsed(true); } }, !collapse ? cardBody() : null)
                    : cardBody()))));
};
TimelineCard.propTypes = {
    onChange: PropTypes.func,
    onActionClick: PropTypes.func
};
